import { StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import "./styles/rsuitjsCustom.css";
import "./styles/map.css";
import { theme } from "../src/styles/theme";
import { ThemeProvider as TokenThemeProvider } from "./design-system/themeContext";
import {
  AddSingleBuildingPage,
  Administration,
  AssetOverview,
  BuildingPassportSharedLayout,
  BuildingProfile,
  Execution,
  Login,
  Modernization,
  ProtectedRoute,
  SharedLayout,
  TechnicalData,
} from "./pages";
import { EnergyPerformanceNewMultiTab } from "./pages/EnergyPerformanceNewMultiTab";
import { LandingPageSharedLayout } from "./pages/LandingPageSharedLayout";
import { Portfolio } from "./pages/Portfolio";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { store } from "./store";
import { ROUTE_PATHS } from "./utils/routerDom";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 10000000, // about 3 hours
      refetchOnWindowFocus: false,
      retry: false,
      // cacheTime: 0,
      staleTime: 10000000,
    },
  },
});
function App() {
  return (
    <TokenThemeProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                <Routes>
                  <Route element={<Login />} path="login" />
                  <Route element={<PrivacyPolicy />} path="privacyPolicy" />
                  <Route
                    element={
                      <ProtectedRoute>
                        <SharedLayout />
                      </ProtectedRoute>
                    }
                    path="/"
                  >
                    <Route element={<LandingPageSharedLayout />} path="">
                      <Route element={<AssetOverview />} path="" />
                      <Route element={<Portfolio />} path="portfolio" />
                    </Route>
                    <Route element={<Administration />} path="administration" />
                    <Route element={<AddSingleBuildingPage />} path={ROUTE_PATHS.addBuilding().pagePath()} />
                    <Route element={<BuildingPassportSharedLayout />} path={ROUTE_PATHS.buildingPassport().pagePath()}>
                      <Route element={<BuildingProfile />} index path={ROUTE_PATHS.buildingProfile().pagePath()} />
                      <Route element={<EnergyPerformanceNewMultiTab />} path="energyPerformance" />
                      <Route element={<TechnicalData />} path="technicalData" />
                      <Route element={<Modernization />} path="modernization" />
                      <Route element={<Execution />} path="execution" />
                    </Route>
                  </Route>
                </Routes>
              </BrowserRouter>
              <ToastContainer />
            </QueryClientProvider>
          </Provider>
        </ThemeProvider>
      </StyledEngineProvider>
    </TokenThemeProvider>
  );
}

export default App;
